import BaseCom from "./common/BaseCom";
import { withParamsAndNavigate } from "./common/WithParamsAndNavigate";
import { NavMenuGlobal } from "./NavMenu";
import SyncStatusList from "./monitor/SyncStatusList";

class Dashboard extends BaseCom {
    componentDidMount() {
        NavMenuGlobal.setPath('Dashboard');
    }

    componentWillUnmount() {
        NavMenuGlobal.clearTitle();
    }

    render() {
        return <SyncStatusList />;
    }
}

export default withParamsAndNavigate(Dashboard);